module.exports = __webpack_public_path__ + "img/vn.78851bfa.svg";